<template>
  <main-container>
    <common-header :isHoken="true"/>
    <section-heading>申請完了</section-heading>
    <contents-container>
      <contents-text>修理サポートのお申込みありがとうございます。<br>サポート申請を受理しました。</contents-text>
      <contents-text>申請番号をお控え頂き、ご不明な点は修理サポートセンターまでお問い合わせください。</contents-text>
      <number-container>
        <span class="label">申請番号</span>
        <br>
        <span class="number">{{advanceEntryNumber}}</span>
      </number-container>
      <contents-text>修理代金サポートセンター<br>0120-914-554<br>年中無休／通話料無料<br>（9：00～20：00）</contents-text>
      <button-container>
        <button-main href="https://pass.auone.jp/anshin/">auスマートパス 安心サービス</button-main>
      </button-container>
    </contents-container>
    <common-footer :isHoken="true"/>
  </main-container>
</template>

<script>
import CommonHeader from '../components/common/CommonHeader'
import CommonFooter from '../components/common/CommonFooter'
import MainContainer from '../components/container/MainContainer'
import ContentsContainer from '../components/container/ContentsContainer'
import NumberContainer from '../components/container/NumberContainer'
import SectionHeading from '../components/heading/SectionHeading'
import ContentsText from '../components/text/ContentsText'
import ButtonContainer from '../components/button/ButtonContainer'
import ButtonMain from '../components/button/ButtonMain'

export default {
  name: "rep050",
  components: {
    CommonHeader,
    CommonFooter,
    MainContainer,
    ContentsContainer,
    NumberContainer,
    SectionHeading,
    ContentsText,
    ButtonContainer,
    ButtonMain
  },
  metaInfo: {
    title: '申請完了',
  },
  computed: {
    advanceEntryNumber() {
      return this.$store.getters.getAdvanceEntryNumber
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
